import * as React from 'react';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';

interface MapProps {
  marker?: boolean;
  zoom?: number;
  latLng: google.maps.LatLngLiteral;
}

const Map = withScriptjs(
  withGoogleMap((props: MapProps) => (
    <GoogleMap
      defaultZoom={props.zoom ? props.zoom : 8}
      center={{ lat: props.latLng.lat, lng: props.latLng.lng }}
      defaultOptions={{
        streetViewControl: false,
        scaleControl: false,
        mapTypeControl: false,
        panControl: false,
        zoomControl: false,
        rotateControl: false,
        fullscreenControl: false,
      }}
    >
      {props.marker && <Marker position={{ lat: props.latLng.lat, lng: props.latLng.lng }} />}
    </GoogleMap>
  )),
);

export default Map;



// WEBPACK FOOTER //
// /www/client/src/components/ContactPage/Map/Map.tsx